/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Active investigation lock summary for USER projection resolver (MDM-MATCH.18h)
 * @export
 * @interface MdmActiveInvestigationLockSummaryDto
 */
export interface MdmActiveInvestigationLockSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    lockId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    lockType?: string;
    /**
     * 
     * @type {Date}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    lockedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    lockedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    incidentId?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmActiveInvestigationLockSummaryDto
     */
    reason?: string;
}

/**
 * Check if a given object implements the MdmActiveInvestigationLockSummaryDto interface.
 */
export function instanceOfMdmActiveInvestigationLockSummaryDto(value: object): value is MdmActiveInvestigationLockSummaryDto {
    return true;
}

export function MdmActiveInvestigationLockSummaryDtoFromJSON(json: any): MdmActiveInvestigationLockSummaryDto {
    return MdmActiveInvestigationLockSummaryDtoFromJSONTyped(json, false);
}

export function MdmActiveInvestigationLockSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmActiveInvestigationLockSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lockId': json['lockId'] == null ? undefined : json['lockId'],
        'lockType': json['lockType'] == null ? undefined : json['lockType'],
        'lockedAt': json['lockedAt'] == null ? undefined : (new Date(json['lockedAt'])),
        'lockedBy': json['lockedBy'] == null ? undefined : json['lockedBy'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MdmActiveInvestigationLockSummaryDtoToJSON(json: any): MdmActiveInvestigationLockSummaryDto {
    return MdmActiveInvestigationLockSummaryDtoToJSONTyped(json, false);
}

export function MdmActiveInvestigationLockSummaryDtoToJSONTyped(value?: MdmActiveInvestigationLockSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lockId': value['lockId'],
        'lockType': value['lockType'],
        'lockedAt': value['lockedAt'] == null ? undefined : ((value['lockedAt']).toISOString()),
        'lockedBy': value['lockedBy'],
        'incidentId': value['incidentId'],
        'reason': value['reason'],
    };
}

